<template>
  <app-modal v-model="isDialogOpened"
             size="md"
             @cancel="closeDialog"
             @ok="confirmClick"
  >
    <template #title>{{ $t('project.signing-checklist.add.step2.SigningChecklistAddStep2RecipientWarningDialog.title') }}</template>

    <template #body>
      <p>{{ $t('project.signing-checklist.add.step2.SigningChecklistAddStep2RecipientWarningDialog.warning') }}</p>
      <p class="mb-0">{{ $t('project.signing-checklist.add.step2.SigningChecklistAddStep2RecipientWarningDialog.confirmText') }}</p>
    </template>
  </app-modal>
</template>

<script>
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'SigningChecklistAddStep2RecipientWarningDialog',
  mixins: [dialogMixin],
  methods: {
    confirmClick () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
